import React, { Component } from 'react';
import Dropzone from 'react-dropzone';

export default class FileUpload extends Component {
  render() {
    const { name, description, handleOnDrop, fullWidth } = this.props;

    return (
      <Dropzone multiple={false} onDrop={acceptedFiles => handleOnDrop(acceptedFiles)}>
        {({ getRootProps, getInputProps }) => (
          <div className={`c-upload-box ${ fullWidth && 'full-width' }`} {...getRootProps()}>
            <input id={name} name={name} {...getInputProps()} className="c-upload-box__input" />
            <small><span className="c-upload-box__p">{description}</span></small>
          </div>
        )}
      </Dropzone>
    );
  }
}